/**
 * OrganizationProviderWrapper
 *
 * This wrapper component accesses the Auth context to get the organizationId
 * and passes it to the OrganizationProvider. This ensures the organization
 * is loaded automatically after login.
 *
 * Separated from AppProviders.tsx to avoid circular import issues.
 */

import React, { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { OrganizationProvider } from '../contexts/OrganizationContext';

interface OrganizationProviderWrapperProps {
  children: ReactNode;
}

const OrganizationProviderWrapper: React.FC<OrganizationProviderWrapperProps> = ({ children }) => {
  const { organizationId } = useAuth();

  return (
    <OrganizationProvider organizationId={organizationId || undefined}>
      {children}
    </OrganizationProvider>
  );
};

export default OrganizationProviderWrapper;
